var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeoLocation = function SvgGeoLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 7.29977L0.433333 5.56644C0.311111 5.51088 0.208333 5.42755 0.125 5.31644C0.0416667 5.20533 0 5.07755 0 4.9331C0 4.78866 0.0388889 4.66088 0.116667 4.54977C0.194444 4.43866 0.3 4.35533 0.433333 4.29977L10.6333 0.516439C10.7667 0.460883 10.8944 0.449772 11.0167 0.483105C11.1389 0.516439 11.2444 0.57755 11.3333 0.666439C11.4222 0.755328 11.4833 0.860883 11.5167 0.983105C11.55 1.10533 11.5389 1.23311 11.4833 1.36644L7.7 11.5664C7.64444 11.7109 7.55833 11.8192 7.44167 11.8914C7.325 11.9637 7.20555 11.9998 7.08333 11.9998C6.96111 11.9998 6.83889 11.9637 6.71667 11.8914C6.59444 11.8192 6.5 11.7109 6.43333 11.5664L4.7 7.29977Z",
    fill: "currentcolor"
  })));
};
export default SvgGeoLocation;